export default "__VITE_ASSET__D$vtXzHL__"